import { emptyApi } from 'src/services/emptyApi';
import { BackgroundTask } from 'src/types/resources/BackgroundTask';
import apiRoutes from 'src/routes/apiRoutes';
import { SingleResponse } from 'src/types/utils';

export type BackgroundTaskName = 'generate_work_experience_from_resume_using_ai';

export type GetBackgroundTasksParams = {
  name?: BackgroundTaskName;
};

export type GetBackgroundTaskParams = {
  taskId: ID;
};

const backgroundTasksApi = emptyApi.injectEndpoints({
  endpoints: builder => ({
    getBackgroundTasks: builder.query<BackgroundTask[], GetBackgroundTasksParams | void>({
      query: params => ({
        url: apiRoutes.backgroundTasks,
        params,
      }),
      providesTags: (result, error, arg) => {
        if (arg && 'name' in arg && arg.name) {
          return [{ type: 'BackgroundTask' as const, id: arg.name }];
        }
        return [{ type: 'BackgroundTask' as const }];
      },
    }),
    getBackgroundTask: builder.query<BackgroundTask, GetBackgroundTaskParams>({
      query: params => ({
        url: apiRoutes.backgroundTask,
        params,
      }),
      transformResponse: (response: SingleResponse<BackgroundTask>) => response.data,
    }),
  }),
});

export const { useGetBackgroundTasksQuery, useGetBackgroundTaskQuery } = backgroundTasksApi;

export default backgroundTasksApi;
